<div class="app">
  <div class="container">
    <app-page-header *ngIf="showPageHeader"></app-page-header>
    <div style="min-height: 100vh;">
      <router-outlet></router-outlet>
    </div>
    <app-page-footer *ngIf="showPageFooter"></app-page-footer>
  </div>
</div>
